import {
  ApolloClient,
  ApolloLink,
  HttpLink,
  InMemoryCache,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";
import { BASE_URL, REFERPRO_TOKEN_NAME } from "../constants";

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors)
    graphQLErrors.map(({ message, locations, path }) =>
      // eslint-disable-next-line no-console
      console.log(
        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
      )
    );
  // eslint-disable-next-line no-console
  if (networkError) console.log(`[Network error]: ${networkError}`);
});

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem(REFERPRO_TOKEN_NAME);

  return {
    headers: {
      ...headers,
      Authorization: token,
    },
  };
});

export const privateClient = new ApolloClient({
  cache: new InMemoryCache(),
  uri: `${BASE_URL}/graphql`,
  link: ApolloLink.from([
    authLink,
    errorLink,
    new HttpLink({ uri: `${BASE_URL}/graphql` }),
  ]),
});

export const publicClient = new ApolloClient({
  cache: new InMemoryCache(),
  uri: `${BASE_URL}/graphql-public`,
  link: ApolloLink.from([
    errorLink,
    new HttpLink({ uri: `${BASE_URL}/graphql-public` }),
  ]),
});
